<!--
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
-->
<!-- IP-NOTICE: PROTECTED -->
<form (ngSubmit)="applyFilter()" class="flex-layout-column flex-layout-align-start flex-layout-gap-10px">
	<div class="flex-layout-row flex-layout-align-start-center flex-layout-gap-10px">
		<h2 *ngIf="hasTitle" class="filter-title">{{ title }}</h2>
		<button *ngIf="showFilters" mat-icon-button class="filter-button" (click)="toggleDisplay()" title="Hide filters" type="button">
			<orbit-icon name="expand_less"></orbit-icon>
		</button>
		<button *ngIf="!showFilters" mat-icon-button class="filter-button" (click)="toggleDisplay()" title="Show filters" type="button">
			<orbit-icon name="expand_more"></orbit-icon>
		</button>
		<ng-container *ngIf="showButtons">
			<span title="Apply Filter">
				<button *ngIf="showFilters" mat-icon-button disabledInteractive class="filter-button" [disabled]="!hasFilters()" [attr.aria-disabled]="!hasFilters()" (click)="applyFilter()" type="submit">
					<orbit-icon name="filter_list"></orbit-icon>
				</button>
			</span>
			<button *ngIf="showFilters" mat-icon-button class="filter-button" (click)="resetFilter()" title="Reset Filter" type="button">
				<orbit-icon name="undo"></orbit-icon>
			</button>
		</ng-container>
	</div>
	<div [hidden]="!showFilters">
		<ng-content select=".filterContent"></ng-content>
	</div>
</form>
